import { api, defineWebModule } from '@itc/sdk';
import { searchBlueprints } from '../shared/endpoints.ts';

// The Blueprint Library in the shell (design §7.5, plan 4A).
export default defineWebModule({
  name: 'blueprints',
  title: 'Blueprints',
  routes: [{ path: '/blueprints', component: () => import('./pages/BlueprintsPage.vue'), meta: { permission: 'blueprints.view', title: 'Blueprints' } }],
  nav: [{ label: 'Blueprints', to: '/blueprints', permission: 'blueprints.view', icon: 'blueprints' }],
  admin: [{ label: 'Blueprints', path: '/admin/blueprints', component: () => import('./admin/AdminPage.vue'), permission: 'blueprints.admin' }],
  search: { permissions: ['blueprints.view'], run: async (q, signal) => (await api(searchBlueprints, { query: { q } }, { signal })).hits },
});
